import React from "react";
import { useTranslation } from "react-i18next";
import BenefitCard from "../BenefitCard/BenefitCard";
import { benefitsData, i18key } from "../../constants/home/benefitsData";
import {
  SectionContainer,
  BenefitsGrid,
  SectionContent,
  ImageWrapper,
} from "./WhyChooseUsSection.styled";
import SectionHeader from "../SectionHeader/SectionHeader";

import TeamImg from "../../assets/pages/home/team.webp";

const WhyChooseUsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <SectionContainer>
      <SectionContent>
        <SectionHeader title={t(`${i18key}.title`)}></SectionHeader>
        <BenefitsGrid>
          {benefitsData.map((benefit, index) => (
            <BenefitCard
              key={index}
              icon={benefit.iconName}
              titleKey={benefit.titleKey}
              descriptionKey={benefit.descriptionKey}
            />
          ))}
        </BenefitsGrid>
      </SectionContent>
      <ImageWrapper>
        <picture>
          <source media="(min-width: 768px)" width={"100%"} srcSet={TeamImg} />
          <img
            src={TeamImg}
            alt="BC consulting tim radi zajedno"
            style={{ width: "100%", height: "auto" }}
          />
        </picture>
      </ImageWrapper>
    </SectionContainer>
  );
};

export default WhyChooseUsSection;
